import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { Product } from 'src/app/shop';

@Component({
  selector: 'app-product-price',
  imports: [FromDictionaryPipe, CurrencyPipe],
  templateUrl: './product-price.component.html',
  styleUrl: './product-price.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductPriceComponent {
  product = input<Product>();
  showLabel = input<boolean>(true);
}
